/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {FilterModel} from '@ion/dls/src/grid/IonGridUtils';

// input selectors ...
const selectIsEditUser       = ({adminUsers: {edit: {isEditing}}}) => isEditing;
const selectIsPreInitialized = ({adminUsers: {isPreInitialized}}) => isPreInitialized;
const selectGridFilterModel  = ({adminUsers: {grid}}) => grid.filterModel;
const selectAddUser          = ({adminUsers: {add}}) => add;
const selectEditUser         = ({adminUsers: {edit}}) => edit;
const selectUserRoles        = ({adminUsers: {roles}}) => roles;
const selectBulkEditUser     = ({adminUsers: {bulkEdit}}) => bulkEdit;

// output selectors ...
export const addUserSelector = createDeepEqualSelector(selectAddUser, (add) => add);

export const editUserSelector = createDeepEqualSelector(selectEditUser, (edit) => edit);

export const userRolesSelector = createDeepEqualSelector(selectUserRoles, (roles) => roles);

export const bulkEditUserSelector = createDeepEqualSelector(selectBulkEditUser, (bulkEdit) => bulkEdit);

export const showEditUserSelector = createSelector(selectIsEditUser,
  (isEditing: boolean): boolean => isEditing
);

export const isPreInitializedSelector = createSelector(selectIsPreInitialized,
  (isPreInitialized: boolean): boolean => isPreInitialized
);

export const adminUsersGridFilterModelSelector = createDeepEqualSelector(selectGridFilterModel,
  (filterModel: FilterModel): FilterModel => filterModel
);
